/** @format */

import { map, retry } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProTipsArticle } from './pro-tips-article.interface';

@Injectable({
	providedIn: 'root'
})
export class ProTipsDataService {
	constructor(private readonly http: HttpClient) {}

	getProTipsData$(
		categoryName: string,
		chainIdentifierAbbr: string,
		noOfPages = 8,
		retries = 0
	): Observable<ProTipsArticle[]> {
		const url = `https://mtools-article-search.dickssportinggoods.com/article-search/${chainIdentifierAbbr}?term=${categoryName}&pageSize=${noOfPages}&relevance=true`;

		return this.http.get(url).pipe(
			map((response: ProTipsArticle[]) => {
				if (response) {
					return response;
				}

				return [] as ProTipsArticle[];
			}),
			retry(retries)
		);
	}
}
